const submissionReferralStatus = {
    REFER : 1,

    CLEAR_REFERRAL : 2,

    RETRACT_REFERRAL : 3,

    DECLINE_REFERRAL : 4,

    PARTIALLY_CLEAR_REFERRAL : 5

};

angular.module('gw-um-j2js')
    .constant('submissionReferralStatus', submissionReferralStatus);